export const widths = Object.freeze({
  "1/2": 1 / 2,
  "1/3": 1 / 3,
  "2/3": 2 / 3,
  "1/4": 1 / 4,
  "3/4": 3 / 4,
  "1/5": 1 / 5,
  "2/5": 2 / 5,
  "3/5": 3 / 5,
  "4/5": 4 / 5,

  "1/10": 1 / 10,
  "2/10": 2 / 10,
  "3/10": 3 / 10,
  "4/10": 4 / 10,
  "5/10": 5 / 10,
  "6/10": 6 / 10,
  "7/10": 7 / 10,
  "8/10": 8 / 10,
  "9/10": 9 / 10,

  "1/24": 1 / 24,
  "2/24": 2 / 24,
  "3/24": 3 / 24,
  "4/24": 4 / 24,
  "5/24": 5 / 24,
  "6/24": 6 / 24,
  "7/24": 7 / 24,
  "8/24": 8 / 24,
  "9/24": 9 / 24,
  "10/24": 10 / 24,
  "11/24": 11 / 24,
  "12/24": 12 / 24,
  "13/24": 13 / 24,
  "14/24": 14 / 24,
  "15/24": 15 / 24,
  "16/24": 16 / 24,
  "17/24": 17 / 24,
  "18/24": 18 / 24,
  "19/24": 19 / 24,
  "20/24": 20 / 24,
  "21/24": 21 / 24,
  "22/24": 22 / 24,
  "23/24": 23 / 24
});
